<template>
	<section class="content">
		<div class="alert alert-info alert-dismissable">
			<i class="fa fa-info"></i>
			<button
				type="button"
				class="close"
				data-dismiss="alert"
				aria-hidden="true"
			>
				×
			</button>
			<b>Novidade!</b> Agora você pode enviar a duplicata para seus clientes assinarem de forma digital. Qualquer dúvida, entre em contato com o suporte!
		</div>
	</section>
</template>

<script>
export default {
	data: () => ({}),
	mounted() {},
	methods: {},
};
</script>



// WEBPACK FOOTER //
// Dashboard.vue?22738dd7